// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
require('css/application.scss')

import "controllers"

require("trix")
require("@rails/actiontext")

import LocalTime from "local-time"
LocalTime.start()

import "stylesheets/application"

require("clipboard")

import "./trix-editor-overrides"
import "./youtube"
import "./confirm"

// document.addEventListener('ajax:beforeSend', (event) => {
//   if (event.detail[1].type != "GET")
//     Turbolinks.clearCache()
// })

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
window.tippy = tippy;

// Polyfil for :scope in nested form controller
import "element-qsa-scope"

// open all trix links in new tab 
document.addEventListener("DOMContentLoaded", function(){
    document.querySelectorAll(".trix-content a").forEach((element) => {
		console.log("yes");
	  element.addEventListener("click", (e) => {
	    e.currentTarget.setAttribute("target", "_blank");
	  });
	});
});

// // Open all external links in a new window
// addEventListener("click", function(event) {
//   var el = event.target

//   if (el.tagName === "A" && !el.isContentEditable && el.host !== window.location.host) {
//     el.setAttribute("target", "_blank")
//   }
// }, true)
